import AppHeader from '@components/AppNavigation/AppHeader';
import HorizontalTabsPage from '@components/AppNavigation/HorizontalTabsPage';
import { PermissionsTable, RolesTable } from '@components/Authorization';
import React, { FC, useMemo } from 'react';
import { AuthorizationPageTabs } from 'types/authorization';

const AuthorizationPage: FC = () => {
	const tabs = useMemo(
		() => [
			{ id: AuthorizationPageTabs.roles, component: <RolesTable /> },
			{ id: AuthorizationPageTabs.permissions, component: <PermissionsTable /> }
		],
		[]
	);

	return (
		<>
			<AppHeader translation="pages.authorization.title" />
			<HorizontalTabsPage
				tabs={tabs}
				routeName="authorization"
				fullRoute="authorization"
			/>
		</>
	);
};

export default AuthorizationPage;
